module.exports = __webpack_public_path__ + "static/media/vf_wearring_core.d7295be4.svg";